<template>
  <div>
    <form @submit.prevent="onSubmit()">
      <p class="text-center text-bold">{{ $t('Reset password') }}</p>
      <p>
        {{ $t('Please enter a email address to the form below.') }}
        {{ $t('Six digits verification code will be sent to the email address from Alphaus.') }}
        {{ $t('The verification code is valid for 900 seconds.') }}
      </p>
      <div class="form-group">
        <label class="text-2">{{ $t('Please type email address.') }}</label>
        <input
          v-validate="'required|email'"
          data-vv-validate-on="change"
          data-vv-as="Email Address"
          name="email"
          class="form-control"
          placeholder="Enter your email"
          type="text"
          v-model="inputEmail"
          @keyup="inputKey"
        />
        <span class="text-2 text-danger">{{ errors.first('email') }}</span>
        <span class="text-2 text-danger" v-if="emailIsWrong">{{
          $t('This email address does not exist.')
        }}</span>
      </div>
      <div class="buttons-w">
        <div class="go-back">
          <span @click="goToLogin">{{ $t('Back') }}</span>
        </div>
        <div class="text-center">
          <Button nativeType="submit" color="primary" :loading="isLoading">
            {{ $t('Confirm submit') }}
          </Button>
        </div>
      </div>
    </form>
    <ConfirmDialog
      :visible.sync="getUsernameDialogVisibility"
      type="warning"
      :loading="isLoading"
      :error="usernameError"
      @updateField="updateFields"
      @submit="handleDialogSubmit"
      @cancel="handleDialogCancel"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Button from '@/components/uikit/Button';
import ConfirmDialog from './ConfirmDialog';

import jaTranslations from '@/i18n/langs/ja';
import enTranslations from '@/i18n/langs/en';

export default {
  name: 'InputMailAddress',
  components: {
    Button,
    ConfirmDialog,
  },
  i18n: {
    en: {
      ...enTranslations,
    },
    ja: {
      ...jaTranslations,
    },
  },
  data() {
    return {
      isLoading: false,
      inputEmail: '',
      emailIsWrong: false,
      usernameError: false,
      showUsernameDialog: false,
      inputSubuserUsername: '',
    };
  },
  computed: {
    getUsernameDialogVisibility: {
      get() {
        return this.showUsernameDialog;
      },
      set(value) {
        this.showUsernameDialog = value;
      },
    },
  },
  watch: {
    inputEmail(value) {
      this.inputEmail = value.replace(/\s+/g, '');
    },
  },
  methods: {
    inputKey() {
      this.emailIsWrong = false;
    },
    onSubmit() {
      this.$validator.validate().then(result => {
        if (result) {
          this.isLoading = true;
          this.$store
            .dispatch('postResetSend', {
              email: this.inputEmail,
              username: this.inputEmail,
              level: 'root',
            })
            .then(res => {
              this.isLoading = false;
              if (res.data.status === 'error') {
                this.isLoading = false;
              } else {
                this.$emit('getVerifyData', res.data.data);
                this.$emit('getUserLevel', {
                  level: 'root',
                  id: this.inputEmail,
                });
                this.$emit('goForward', 1);
              }
            })
            .catch(() => {
              this.isLoading = false;
              this.emailIsWrong = true;
              this.showUsernameDialog = true;
              this.$message.error(this.$t('An error has occurred.'));
            });
        }
      });
    },
    goToLogin() {
      this.$router.push('/login').catch(() => {});
    },
    updateFields(inputUsername) {
      this.inputSubuserUsername = inputUsername;
      this.usernameError = false;
    },
    handleDialogCancel() {
      this.showUsernameDialog = false;
    },
    async handleDialogSubmit() {
      this.isLoading = true;
      this.$store
        .dispatch('postResetSend', {
          email: this.inputEmail,
          username: this.inputSubuserUsername,
          level: 'subuser',
        })
        .then(res => {
          this.isLoading = false;
          if (res.data.status === 'error') {
            this.isLoading = false;
          } else {
            this.$emit('getVerifyData', res.data.data);
            this.$emit('getUserLevel', {
              level: 'subuser',
              id: this.inputSubuserUsername,
            });
            this.$emit('goForward', 1);
          }
        })
        .catch(() => {
          this.isLoading = false;
          this.usernameError = true;
          this.$message.error(this.$t('An error has occurred.'));
        });
    },
    ...mapActions('auth', {
      checkToken: 'checkToken',
      setAccessToken: 'setAccessToken',
      getAccessToken: 'getAccessToken',
    }),
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/mo-custom';
.buttons-w {
  display: flex;
  justify-content: space-between;
}

.go-back {
  span {
    color: $primary-color;
    cursor: pointer;
    line-height: 30px;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
